import useUiuxStore, { ToastType } from 'src/store/useUiuxStore';

// 전역 토스트 함수를 위한 변수
let addToastFunction: ((type: ToastType, message: string, duration?: number) => void) | null = null;

// 토스트 함수를 설정하는 함수
export const setToastFunction = (addToast: (type: ToastType, message: string, duration?: number) => void) => {
  addToastFunction = addToast;
};

// 전역 토스트 함수들
export const showToast = (type: ToastType, message: string, duration?: number) => {
  if (addToastFunction) {
    addToastFunction(type, message, duration);
  } else {
    // fallback: console.log
    console.log(`[${type.toUpperCase()}] ${message}`);
  }
};

export const showSuccess = (message: string, duration?: number) => {
  showToast('success', message, duration ?? 1500);
};

export const ShowSuccessFetch = (
  setMessage: (message: string) => void,
  message: string,
  duration?: number
) => {
  setMessage(message);
//   setTimeout(() => setMessage(""), duration ?? 1500);
  showSuccess(message, duration ?? 1500);
};

export const showError = (message: string, duration?: number) => {
  showToast('error', message, duration ?? 1500);
};

export const showWarning = (message: string, duration?: number) => {
  showToast('warning', message, duration ?? 1500);
};

export const showInfo = (message: string, duration?: number) => {
  showToast('info', message, duration ?? 1500);
}; 

